<div
  [ngSwitch]="templateId"
  class="cigna-contract-container"
  [ngClass]="renderMode"
>
  <ng-container *ngSwitchCase="'personalDetailsTemplate'">
    <ng-container *ngTemplateOutlet="personalDetailsTemplate"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'addressTemplate'">
    <ng-container *ngTemplateOutlet="addressTemplate"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'commercialAppointmentTemplate'">
    <ng-container
      *ngTemplateOutlet="commercialAppointmentTemplate"
    ></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="'commercialContractorBoxTemplate'">
    <ng-container
      *ngTemplateOutlet="commercialContractorBoxTemplate"
    ></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'exitConfirmBox'">
    <ng-container *ngTemplateOutlet="exitConfirmBox"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'ifpContractorBoxTemplate'">
    <ng-container *ngTemplateOutlet="ifpContractorBoxTemplate"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'maContractorBoxTemplate'">
    <ng-container *ngTemplateOutlet="maContractorBoxTemplate"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'csbContractorBoxTemplate'">
    <ng-container *ngTemplateOutlet="csbContractorBoxTemplate"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'submissionFinalBoxTemplate'">
    <ng-container *ngTemplateOutlet="submissionFinalBoxTemplate"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'thanksTemplate'">
    <ng-container *ngTemplateOutlet="thanksTemplate"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'restartTemplate'">
    <ng-container *ngTemplateOutlet="thanksTemplate"></ng-container>
  </ng-container>
</div>

<ng-template #personalDetailsTemplate>
  <div class="mfa-verfigy-dialog">
    <cigna-cfb-back-and-close-button
      [isBackBtnEnabled]="false"
      (closeButtonClick)="onPersonalDetailsClosed()"
      [renderMode]="'dialogModal'"
    ></cigna-cfb-back-and-close-button>
    <div
      mat-dialog-title
      fxLayout="row"
      fxLayoutAlign="space-between start"
      id="cwcDialogHeader"
    >
      <h2
        data-test-id="hdr"
        class="cwc-title"
        aria-label="cwc header"
        tabindex="0"
      >
        {{ 'onboarding.contactInfo.header' | translate }}
      </h2>
    </div>

    <div
      mat-dialog-body
      fxLayout="row"
      fxLayoutAlign="space-between start"
      id="cwcDialogBody"
    >
      <span
        data-test-id="hdr1"
        class="cwc-sub-title"
        aria-label="cwc header"
        tabindex="0"
      >
        {{ 'onboarding.contactInfo.body' | translate }}
      </span>
    </div>

    <mat-dialog-content aria-labelledby="matHeading" data-test-id="">
      <div class="enter-data-field">
        <form
          id="broker.emailDialog"
          [formGroup]="verifyForm"
          method="POST"
          name="verifyForm"
        >
          <div class="float-container">
            <div class="float-child">
              <div>
                <div class="cwc-label">
                  {{ 'onboarding.contactInfo.firstName' | translate }}
                </div>
                <mat-form-field
                  [hideRequiredMarker]="true"
                  appearance="outline"
                >
                  <input
                    type="email"
                    matInput
                    maxlength="50"
                    autocomplete="off"
                    formControlName="firstName"
                    data-test-id="firstName"
                    aria-label="firstName Input"
                  />
                  <mat-error
                    *ngIf="
                      verifyForm.get('firstName')?.invalid &&
                      (verifyForm.get('firstName')?.dirty ||
                        verifyForm.get('firstName')?.touched)
                    "
                  >
                    <div
                      class="input-error"
                      *ngIf="verifyForm.get('firstName')?.hasError('required')"
                    >
                      <cigna-icon
                        type="exclamation-triangle"
                        class="alert-icon"
                      ></cigna-icon>
                      {{ 'global.required' | translate }}
                    </div>
                    <div
                      class="input-error"
                      *ngIf="verifyForm.get('firstName')?.hasError('minlength')"
                    >
                      <cigna-icon
                        type="exclamation-triangle"
                        class="alert-icon"
                      ></cigna-icon>
                      {{ 'forgotUsername.firstNameMinLength' | translate }}
                    </div>
                    <div
                      class="input-error"
                      *ngIf="
                    verifyForm.get('firstName')?.errors?.['invalidName'] &&
                      !verifyForm
                        .get('firstName')
                        ?.hasError('minlength')
                    "
                    >
                      <cigna-icon
                        type="exclamation-triangle"
                        class="alert-icon"
                      ></cigna-icon>
                      {{ 'forgotUsername.firstNameValid' | translate }}
                    </div>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="float-child">
              <div>
                <div class="cwc-label">
                  {{ 'onboarding.contactInfo.lastName' | translate }}
                </div>
                <mat-form-field
                  [hideRequiredMarker]="true"
                  appearance="outline"
                >
                  <input
                    matInput
                    maxlength="50"
                    autocomplete="off"
                    formControlName="lastName"
                    data-test-id="lastName"
                    aria-label="lastName Input"
                  />
                  <mat-error
                    *ngIf="
                      verifyForm.get('lastName')?.invalid &&
                      (verifyForm.get('lastName')?.dirty ||
                        verifyForm.get('lastName')?.touched)
                    "
                  >
                    <div
                      class="input-error"
                      *ngIf="verifyForm.get('lastName')?.hasError('required')"
                    >
                      <cigna-icon
                        type="exclamation-triangle"
                        class="alert-icon"
                      ></cigna-icon>
                      {{ 'global.required' | translate }}
                    </div>
                    <div
                      class="input-error"
                      *ngIf="verifyForm.get('lastName')?.hasError('minlength')"
                    >
                      <cigna-icon
                        type="exclamation-triangle"
                        class="alert-icon"
                      ></cigna-icon>
                      {{ 'forgotUsername.firstNameMinLength' | translate }}
                    </div>
                    <div
                      class="input-error"
                      *ngIf="
                    verifyForm.get('lastName')?.errors?.['invalidName'] &&
                      !verifyForm
                        .get('lastName')
                        ?.hasError('minlength')
                    "
                    >
                      <cigna-icon
                        type="exclamation-triangle"
                        class="alert-icon"
                      ></cigna-icon>
                      {{ 'forgotUsername.firstNameValid' | translate }}
                    </div>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="float-container">
            <div class="float-child email-responsive">
              <div>
                <div class="cwc-label">
                  {{ 'onboarding.contactInfo.emailAddress' | translate }}
                </div>
                <mat-form-field
                  [hideRequiredMarker]="true"
                  appearance="outline"
                >
                  <input
                    matInput
                    autocomplete="off"
                    formControlName="emailAddress"
                    data-test-id="emailAddress"
                    aria-label="emailAddress Input"
                  />
                  <mat-error
                    *ngIf="
                      verifyForm.get('emailAddress')?.invalid &&
                      (verifyForm.get('emailAddress')?.dirty ||
                        verifyForm.get('emailAddress')?.touched)
                    "
                  >
                    <div
                      class="input-error"
                      *ngIf="verifyForm.get('emailAddress')?.errors?.['required']"
                    >
                      <cigna-icon
                        type="exclamation-triangle"
                        class="alert-icon"
                      ></cigna-icon>
                      {{ 'global.required' | translate }}
                    </div>
                    <div
                      class="input-error"
                      *ngIf="verifyForm.get('emailAddress')?.errors?.['email'] &&
                !verifyForm.get('emailAddress')?.errors?.['required']"
                    >
                      <cigna-icon
                        type="exclamation-triangle"
                        class="alert-icon"
                      ></cigna-icon>
                      {{
                        'brokerRegistration.emailValidationFailed' | translate
                      }}
                    </div>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="float-child mobile-responsive">
              <div>
                <div class="cwc-label">
                  {{ 'onboarding.contactInfo.mobile' | translate }}
                </div>
                <mat-form-field
                  [hideRequiredMarker]="true"
                  appearance="outline"
                >
                  <input
                    matInput
                    maxlength="10"
                    (keypress)="numberOnly($event)"
                    minlength="10"
                    maxlength="10"
                    mask="000-000-0000"
                    autocomplete="off"
                    formControlName="mobileNumber"
                    data-test-id="mobileNumber"
                    aria-label="mobileNumber Input"
                  />
                  <mat-error
                    *ngIf="
                      verifyForm.get('mobileNumber')?.invalid &&
                      (verifyForm.get('mobileNumber')?.dirty ||
                        verifyForm.get('mobileNumber')?.touched)
                    "
                  >
                    <div
                      class="input-error"
                      *ngIf="
                        verifyForm.get('mobileNumber')?.hasError('required')
                      "
                    >
                      <cigna-icon
                        type="exclamation-triangle"
                        class="alert-icon"
                      ></cigna-icon>
                      {{ 'global.required' | translate }}
                    </div>
                  </mat-error>

                  <mat-error
                    class="input-error npn-error"
                    *ngIf="
                      (verifyForm.get('mobileNumber')?.touched &&
                        verifyForm.get('mobileNumber')?.errors &&
                        verifyForm
                          .get('mobileNumber')
                          ?.hasError('invalidZeroControl')) ||
                      verifyForm.get('mobileNumber')?.hasError('minlength') ||
                      verifyForm.get('mobileNumber')?.hasError('maxlength')
                    "
                    data-test-id="invalidNPN"
                    attr.aria-label="  {{ 'global.invalidMobile' | translate }}"
                  >
                    <cigna-icon
                      type="exclamation-triangle"
                      class="alert-icon"
                    ></cigna-icon>
                    {{ 'global.invalidMobile' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="float-container">
            <div class="float-child agency-desktop">
              <div>
                <div class="cwc-label">
                  {{ 'onboarding.contactInfo.agencyName' | translate }}
                </div>
                <mat-form-field
                  [hideRequiredMarker]="true"
                  appearance="outline"
                >
                  <input
                    matInput
                    maxlength="50"
                    autocomplete="off"
                    formControlName="agencyName"
                    data-test-id="agencyName"
                    aria-label="agencyName Input"
                  />
                  <mat-error
                    *ngIf="
                      verifyForm.get('agencyName')?.invalid &&
                      (verifyForm.get('agencyName')?.dirty ||
                        verifyForm.get('agencyName')?.touched)
                    "
                  >
                    <div
                      class="input-error"
                      *ngIf="verifyForm.get('agencyName')?.hasError('required')"
                    >
                      <cigna-icon
                        type="exclamation-triangle"
                        class="alert-icon"
                      ></cigna-icon>
                      {{ 'global.required' | translate }}
                    </div>
                    <div
                      class="input-error"
                      *ngIf="
                        verifyForm.get('agencyName')?.hasError('minlength')
                      "
                    >
                      <cigna-icon
                        type="exclamation-triangle"
                        class="alert-icon"
                      ></cigna-icon>
                      {{ 'forgotUsername.firstNameMinLength' | translate }}
                    </div>
                    <div
                      class="input-error"
                      *ngIf="
                    verifyForm.get('agencyName')?.errors?.['invalidName'] &&
                      !verifyForm
                        .get('agencyName')
                        ?.hasError('minlength')
                    "
                    >
                      <cigna-icon
                        type="exclamation-triangle"
                        class="alert-icon"
                      ></cigna-icon>
                      {{ 'forgotUsername.firstNameValid' | translate }}
                    </div>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="float-child">
              <div>
                <div class="cwc-label">
                  {{ 'onboarding.contactInfo.npn' | translate }}
                </div>
                <mat-form-field
                  [hideRequiredMarker]="true"
                  appearance="outline"
                >
                  <input
                    matInput
                    (keypress)="numberOnly($event)"
                    minlength="2"
                    maxlength="10"
                    autocomplete="off"
                    formControlName="npn"
                    data-test-id="npn"
                    aria-label="npn Input"
                    class="npn-field"
                  />
                  <mat-error
                    *ngIf="
                      verifyForm.get('npn')?.hasError('required') &&
                      (verifyForm.get('npn')?.dirty ||
                        verifyForm.get('npn')?.touched)
                    "
                    data-test-id="lblNpnRequired"
                    attr.aria-label="  {{
                      'brokerRegistration.npnRequired' | translate
                    }}"
                  >
                    <div class="input-error">
                      <cigna-icon
                        type="exclamation-triangle"
                        class="alert-icon"
                      ></cigna-icon>
                      {{ 'global.required' | translate }}
                    </div>
                  </mat-error>
                  <mat-error
                    class="input-error npn-error"
                    *ngIf="
                      (verifyForm.get('npn')?.touched &&
                        verifyForm.get('npn')?.errors &&
                        verifyForm
                          .get('npn')
                          ?.hasError('invalidZeroControl')) ||
                      verifyForm.get('npn')?.hasError('minlength') ||
                      verifyForm.get('npn')?.hasError('maxlength')
                    "
                    data-test-id="invalidNPN"
                    attr.aria-label="  {{
                      'brokerRegistration.invalidNPN' | translate
                    }}"
                  >
                    <cigna-icon
                      type="exclamation-triangle"
                      class="alert-icon"
                    ></cigna-icon>
                    {{ 'brokerRegistration.invalidNPN' | translate }}
                  </mat-error>
                </mat-form-field>
                <div class="link-text fpn">
                  <a
                    (click)="navigateToNpn()"
                    class="link"
                    class="findNpn-hyperlink"
                  >
                    {{ 'onboarding.contactInfo.findNPN' | translate
                    }}<cigna-icon
                      type="external-link"
                      class="img-el"
                    ></cigna-icon
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class="cwc-btn-section">
        <button
          type="submit"
          mat-raised-button
          cg-mat-btn-type="primary"
          [disabled]="verifyForm.invalid"
          class="ls-button-fill"
          data-test-id="btn-submit"
          (click)="continue()"
        >
          {{ 'onboarding.contactInfo.continue' | translate }}
        </button>
        <span
          mat-raised-button
          class="cancel-btn"
          data-test-id="btn-cancel"
          (click)="onPersonalDetailsClosed()"
          >{{ 'onboarding.contactInfo.cancel' | translate }}</span
        >
      </div>
    </mat-dialog-actions>
  </div>
</ng-template>
<ng-template #addressTemplate>
  <cigna-cfb-back-and-close-button
    (backButtonClick)="addressBackClicked()"
    (closeButtonClick)="showExitDialog('exit')"
    [renderMode]="'dialogModal'"
  ></cigna-cfb-back-and-close-button>

  <cigna-cfb-contractor-address-form
    (cancelClicked)="onAddressFormCancelled()"
    (mailAddressRequested)="mailAddressToggle($event)"
    (continueClicked)="onAddressFormContinue()"
  ></cigna-cfb-contractor-address-form>
</ng-template>

<ng-template #commercialAppointmentTemplate>
  <div class="commercialAppointmentBtns">
    <cigna-cfb-back-and-close-button
      (backButtonClickCommercial)="commercialAppointmentBtnsBackClicked()"
      (backButtonClickIfp)="ifpAppointmentBtnsBackClicked()"
      (backButtonClickMa)="maAppointmentBtnsBackClicked()"
      (backButtonClickCsb)="csbAppointmentBtnsBackClicked()"
      (closeButtonClick)="showExitDialog('exit')"
      (backButtonClickRestart)="csbContractorBoxBackClicked()"
      [lob]="currentLob"
      [renderMode]="'dialogModal'"
    ></cigna-cfb-back-and-close-button>
  </div>

  <cigna-cfb-contractor-confirm-box
    #contractorConfirmBox
    (yesClicked)="onCommercialAppointmentOpted()"
    (noClicked)="onCommercialAppointmentNotOpted()"
    (ifpYesClicked)="onIfpAppointmentOpted()"
    (ifpNoClicked)="onIfpAppointmentNotOpted()"
    (maYesClicked)="onMaAppointmentOpted()"
    (maNoClicked)="onMaAppointmentNotOpted()"
    [lob]="currentLob"
    (CsbYesClicked)="onCsbYesClicked()"
    (CsbNoClicked)="onCsbNoClicked()"
    (restartClicked)="onRestartClicked()"
    (exitClicked)="onExitClicked()"
  >
  </cigna-cfb-contractor-confirm-box>
</ng-template>

<ng-template #commercialContractorBoxTemplate>
  <div class="commercialContractorBtns">
    <cigna-cfb-back-and-close-button
      (backButtonClick)="commercialContractorBoxBackClicked()"
      (closeButtonClick)="showExitDialog('exit')"
      [renderMode]="'dialogModal'"
    ></cigna-cfb-back-and-close-button>
  </div>

  <cigna-cfb-commercial-contractor-box
    (cancelClicked)="showExitDialog('exit')"
    (continueClicked)="onContractorBoxContinueClicked()"
  >
  </cigna-cfb-commercial-contractor-box>
</ng-template>

<ng-template #ifpContractorBoxTemplate>
  <div class="commercialContractorBtns">
    <cigna-cfb-back-and-close-button
      (backButtonClick)="ifpContractorBoxBackClicked()"
      (closeButtonClick)="showExitDialog('exit')"
      [renderMode]="'dialogModal'"
    ></cigna-cfb-back-and-close-button>
  </div>

  <cigna-cfb-ifp-contractor-box
    (cancelClicked)="showExitDialog('exit')"
    (continueClicked)="onIfpContinueClicked()"
  >
  </cigna-cfb-ifp-contractor-box>
</ng-template>

<ng-template #exitConfirmBox>
  <cigna-cfb-contractor-confirm-box> </cigna-cfb-contractor-confirm-box>
</ng-template>

<ng-template #maContractorBoxTemplate>
  <div class="commercialContractorBtns">
    <cigna-cfb-back-and-close-button
      (backButtonClick)="maContractorBoxBackClicked()"
      (closeButtonClick)="showExitDialog('exit')"
      [renderMode]="'dialogModal'"
    ></cigna-cfb-back-and-close-button>
  </div>

  <cigna-cfb-ma-contractor-box
    (cancelClicked)="showExitDialog('exit')"
    (continueClicked)="onMaContinueClicked()"
  >
  </cigna-cfb-ma-contractor-box>
</ng-template>

<ng-template #csbContractorBoxTemplate>
  <div class="commercialContractorBtns">
    <cigna-cfb-back-and-close-button
      (backButtonClick)="csbContractorBoxBackClicked()"
      (closeButtonClick)="showExitDialog('exit')"
      [renderMode]="'dialogModal'"
    ></cigna-cfb-back-and-close-button>
  </div>
  <cigna-cfb-csb-contractor-box
    (continueClicked)="onCsbContinueClicked()"
    (cancelClicked)="showExitDialog('exit')"
  >
  </cigna-cfb-csb-contractor-box>
</ng-template>

<ng-template #submissionFinalBoxTemplate>
  <cigna-cfb-submission-final-box (closeClicked)="onFinalSubmissionClosed()">
  </cigna-cfb-submission-final-box>
</ng-template>

<ng-template #thanksTemplate>
  <cigna-cfb-submission-final-box
    (closeClicked)="onFinalSubmissionClosed()"
    renderMode="webPage"
  >
  </cigna-cfb-submission-final-box>
</ng-template>

<ng-template #restartTemplate> </ng-template>
